module.exports = __webpack_public_path__ + "img/web_ilt_1.84e9d783.jpg";